import React from 'react';
import { dateFormat } from '../../helpers/dateFormatter';

export default function({ datetime, format }) {
  return datetime ? <time dateTime={datetime}>{dateFormat(datetime, format)}</time> : <>-</>;
}
